<template>
  <v-container class="pa-0">
    <v-row>
      <v-col class="py-0 px-2" cols="3">
        <label>Ordenar por</label>
        <v-select
          v-model="orderBy"
          :items="orderByList"
          item-value="valor"
          item-text="descricao"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          outlined
          @change="getList({ ...filterData, ...orderBy }, 1)"
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="d-flex justify-end pb-2 px-0 mb-0" cols="4" sm="6" xs="12">
        <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          class="mb-1" 
                          color="primary" 
                          icon
                          small
                          @click=modalVideo()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Como corrigir o erro no formulário do recurso de glosa</span>
                        </v-tooltip>
                  </span>
        <v-btn
          color="primary"
          depressed
          outlined
          height="30px"
          small
          class="px-2 mr-2 mb-0 mt-2"
          to="/recebiveis/recursosdeglosa/historicodeuploads"
          >Gestão de upload</v-btn>
          <v-btn v-if="enableFinaliza"
            color="primary"
            class="px-2 mr-2 mb-0 mt-2"
            height="30px"
            small
            @click="openModal()"
            :disabled="list.length == 0"
            depressed
          >
            Finalizar envio
          </v-btn>
        <v-btn
          color="primary"
          class="mb-0 mt-2"
          height="30px"
          text
          @click="downloadFile('getcsvrecursosglosa', filterData, true)"
          :disabled="list.length == 0"
        >
          <v-icon small class="pr-2">fa-download</v-icon>
          Exportar resultado
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="ma-0 pl-4 pr-1" style="background-color: #d1dcea">
      <v-col cols="2" class="pa-4">
        <div class="px-0 pt-1">
          <b class="pr-2">TOTAIS</b>
        </div>
      </v-col>
      <v-col cols="10" class="pa-0">
        <v-row class="ma-0 pt-2 pr-9" style="justify-content: end">
          <v-spacer />
          <v-col
            class="text-list text-right px-0 py-1"
            style="max-width: 11.6%"
          >
            <small>Informado</small><br />
            <b
              ><span>{{ totais.valor_informado | formatPrice }}</span></b
            >
          </v-col>
          <v-col class="text-list text-right px-0 py-1" style="max-width: 8.6%"
            ><small>Conciliado</small><br /><b
              >{{ totais.perc_conciliado | formatPrice }}%</b
            ></v-col
          >
          <v-col
            class="text-list text-right px-0 py-1"
            style="max-width: 11.6%"
          >
            <small>Liberado</small><br />
            <b
              ><span style="color: rgb(50, 184, 139)">{{
                totais.valor_liberado | formatPrice
              }}</span></b
            >
          </v-col>

          <v-col
            class="text-list text-right px-0 py-1"
            style="max-width: 11.6%"
          >
            <small>Recursado</small><br />
            <b
              ><span style="color: rgb(50, 184, 139)">{{
                totais.valor_recursado | formatPrice
              }}</span></b
            >
          </v-col>

          <v-col
            class="text-list text-right px-0 py-1"
            style="max-width: 11.6%"
          >
            <small>Acatado</small><br />
            <b
              ><span style="color: red">{{
                totais.valor_acatado | formatPrice
              }}</span></b
            >
          </v-col>

          <v-col
            class="text-list text-right px-0 py-1"
            style="max-width: 11.6%"
          >
            <small>Lib. produção</small><br />
            <b
              ><span style="color: rgb(50, 184, 139)">{{
                totais.valor_liberado_producao | formatPrice
              }}</span></b
            >
          </v-col>
          <v-col
            class="text-list text-right px-0 py-1"
            style="max-width: 11.6%"
          >
            <small>Glosa inicial</small><br />
            <b
              ><span style="color: red">{{
                totais.valor_glosado | formatPrice
              }}</span></b
            >
          </v-col>
          <v-col
            class="text-list text-right px-0 py-1"
            style="max-width: 11.6%"
          >
            <small>Lib. recurso</small><br />
            <b
              ><span style="color: rgb(50, 184, 139)">{{
                totais.valor_liberado_recurso | formatPrice
              }}</span></b
            >
          </v-col>

          <v-col
            class="text-list text-right px-0 py-1"
            style="max-width: 11.6%"
          >
            <small>Glosa mantida</small><br />
            <b
              ><span style="color: red">{{
                totais.valor_glosa_mantida | formatPrice
              }}</span></b
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <p class="text-center pt-6 pa-2" v-show="list.length === 0">
      Não há dados disponíveis
    </p>
    <v-expansion-panels focusable v-model="panel" v class="px-0 pt-3">
      <v-expansion-panel
        v-for="(pagamento, ind) in list"
        :key="ind"
        :value="ind"
        class="mb-4 pa-0"
      >
        <v-expansion-panel-header
          class="py-0 px-3 pl-1"
          @click="openPanel(ind, pagamento)"
        >
          <v-row class="ma-0">
            <v-col cols="2" class="pa-0">
              <div class="check-header-rec">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="pa-0">
                      <v-icon
                        v-if="pagamento.envio_manual"
                        style=" color: #979797;"
                        size="13px"
                        class="pr-1"
                        >fa-solid fa-dolly</v-icon 
                      >
                      <v-icon
                        v-else
                        style=" color: #979797;"
                        size="13px"
                        class="pr-1"
                        >fa-solid fa-robot</v-icon 
                      >
                    </span>
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    "
                    >{{ pagamento.envio_manual ? 'Envio manual' : 'Envio automático'}}</span
                  >
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="pa-0">
                      <v-icon
                        :color="getStatusData(pagamento.etapa, 'cor')"
                        size="13px"
                        class="pr-1"
                        >fas fa-circle</v-icon
                      >
                    </span>
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    "
                    >{{ getStatusData(pagamento.etapa, "descricao") }}</span
                  >
                </v-tooltip>
                <!-- Mudar o IF -->
                <v-tooltip bottom v-if="pagamento.erro_validacao || (pagamento.pendencia_id > 0 && grupoEconomico == 167 && userData.UsuarioTradimus)">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="pa-0">
                      <v-icon color="error" size="13px" class="pr-1"
                        >fas fa-exclamation-triangle</v-icon
                      >
                    </span>
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    "
                    >{{pagamento.pendencia_id >0? pagamento.pendencia_descricao:"Erro no upload"}}</span
                  >
                </v-tooltip>
                <!-- Check de quitação - INÍCIO -->
                <v-tooltip bottom v-if="pagamento.quitado">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="pr-1"
                        color="success"
                        small
                        v-bind="attrs"
                        v-on="on"
                        >far fa-check-square</v-icon
                      >
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;"
                      >Pagamento quitado</span
                    >
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="pr-1"
                        color="principal"
                        small
                        v-bind="attrs"
                        v-on="on"
                        >far fa-square</v-icon
                      >
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;"
                      >Pagamento aguardando quitação</span
                    >
                  </v-tooltip>
              </div>
              <div class="px-0 py-3" style="margin-left:75px!important">
                <b class="pr-2"
                  ><small>Data do pagamento</small><br />{{
                    pagamento.data_pagamento | formatDate
                  }}</b
                >
              </div>
            </v-col>

            <v-col cols="10" class="pa-0">
              <v-row class="ma-0">
                <v-col
                  class="text-list text-left px-0 py-3"
                  style="min-width: 100px"
                  ><small>Prazo do recurso</small><br />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="pa-0">
                        <span
                          :class="
                            getColorByDate(pagamento.data_prazo_recebimento)
                          "
                          >{{
                            pagamento.data_prazo_recebimento | formatDate
                          }}</span
                        >
                      </span>
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                    >
                      {{ getPrazoEmDias(pagamento.data_prazo_recebimento) }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  class="text-list text-left px-0 pt-3 pb-2"
                  style="min-width: 160px"
                  ><b>{{ pagamento.oper_nome }}</b
                  ><br />{{ pagamento.prest_nome }}</v-col
                >
                <v-col class="text-list text-right px-0 py-3"
                  ><small>Informado</small><br /><b>{{
                    pagamento.valor_informado | formatPrice
                  }}</b></v-col
                >
                <v-col
                  class="text-list text-right px-0 py-1"
                  style="max-width: 8.6%"
                  ><small>Conciliado</small><br /><b>{{
                    pagamento.perc_conciliado | formatPrice
                  }}</b></v-col
                >
                <v-col class="text-list text-right px-0 py-3"
                  ><small>Liberado</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                      pagamento.valor_liberado | formatPrice
                    }}</span></b
                  ></v-col
                >

                <v-col class="text-list text-right px-0 py-3"
                  ><small>Recursado</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                      pagamento.valor_recursado | formatPrice
                    }}</span></b
                  ></v-col
                >

                <v-col class="text-list text-right px-0 py-3"
                  ><small>Acatado</small><br />
                  <b
                    ><span style="color: red">{{
                      pagamento.valor_acatado | formatPrice
                    }}</span></b
                  >
                </v-col>

                <v-col class="text-list text-right px-0 py-3">
                  <small>Lib. produção</small><br />
                  <b
                    ><span style="color: rgb(50, 184, 139)">{{
                      pagamento.valor_liberado_producao | formatPrice
                    }}</span></b
                  >
                </v-col>

                <v-col class="text-list text-right px-0 py-3"
                  ><small> Glosa inicial</small><br /><b
                    ><span style="color: red">{{
                      pagamento.valor_glosado | formatPrice
                    }}</span></b
                  >
                </v-col>

                <v-col class="text-list text-right px-0 py-3">
                  <small>Lib. recurso</small><br />
                  <b
                    ><span style="color: rgb(50, 184, 139)">{{
                      pagamento.valor_liberado_recurso | formatPrice
                    }}</span></b
                  >
                </v-col>

                <v-col class="text-list text-right px-0 py-3"
                  ><small>Glosa mantida</small><br /><b>
                    <span style="color: red">{{
                      pagamento.valor_glosa_mantida | formatPrice
                    }}</span></b
                  ></v-col
                >
                <v-col class="px-1 py-3" style="max-width: 20px">
                  <template v-if="pagamento.itg_sdi_rec && pagamento.perc_conciliado > 0">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="mr-3 mt-3 mb-0"
                          :color="pagamento.status_integracao_erp !=3? '#979797': estadoList[pagamento.status_integracao_erp_rec].color"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="acaoExe($event, pagamento)"
                          >fa fa-exchange-alt</v-icon>
                      </template>
                      <span
                        class="px-2 py-1 ma-0"
                        style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                        "
                        >{{estadoList[pagamento.status_integracao_erp_rec].descricao}}</span>
                    </v-tooltip>
                  </template>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- Mudar o IF -->
          <v-alert
            v-if="pagamento.erro_validacao || (pagamento.pendencia_id > 0 && grupoEconomico == 167 && userData.UsuarioTradimus)"
            dense
            outlined
            type="error"
            class="text-left mb-0"
            ><b>{{ (pagamento.pendencia_id > 0 && grupoEconomico == 167 && userData.UsuarioTradimus)?  (pagamento.pendencia_descricao+": "+pagamento.mensagem_pendencia) : pagamento.mensagem_erro_validacao }}</b></v-alert
          >
          <v-row
            class="ma-0"
            style="
              border-left: 1px solid rgba(0, 0, 0, 0.1);
              border-right: 1px solid rgba(0, 0, 0, 0.1);
              background-color: #eff3f8;
            "
          >
            <v-col style="padding-left: 18px; font-size: 17px" cols="5">
              <small
                v-if="
                  pagamento.etapa == 99 &&
                  pagamento.user_id_alteracao > 1 &&
                  pagamento.username_alteracao
                "
                >Concluído:
                <b
                  >{{ pagamento.data_evento_atualizado | formatDateHour }} por
                  {{ pagamento.username_alteracao }}</b
                ></small
              >
              <small v-else-if="pagamento.etapa == 99"
                >Concluído:
                <b>{{
                  pagamento.data_evento_atualizado | formatDateHour
                }}</b></small
              >
              <small v-else>
                Atualizado:
                <b>{{
                  pagamento.data_evento_atualizado | formatDateHour
                }}</b></small
              >
            </v-col>
            <v-col style="margin-left: -30px; font-size: 17px" cols="3">
              <small
                >Primeira publicação:
                <b>{{
                  pagamento.data_primeira_publicacao | formatDateHour
                }}</b></small
              >
            </v-col>
            <v-spacer></v-spacer>
            <v-col style="font-size: 17px" cols="4" class="text-right pr-0">
              <v-btn
                color="primary"
                small
                text
                :to="`/recebiveis/pagamentospublicados/detalhespagamento/${pagamento.id}`"
              >
                <v-icon small class="pr-2">fa-external-link-alt</v-icon>
                Detalhes do pagamento
              </v-btn>
            </v-col>
          </v-row>
          <PagamentoDataTable
            :confirmLiberarEdicao="
              (pagamentoIdPrestador) =>
                confirmLiberarEdicao(pagamentoIdPrestador, true)
            "
            :headers="getHeadersLogin(pagamento.etapa)"
            :list="pagtoList"
            :dadosPagamento="pagamento"
            :userName="userName"
            :userData="userData"
          />
          <v-col class="d-flex justify-end py-0 px-0" cols="12">
            <p
              v-if="pagamento.is_editing == true && !!pagamento.username_editing"
              class="pt-1"
              style="font-size: 10px"
            >
              <v-progress-circular
                x-small
                :size="10"
                :width="1"
                color="primary"
                class="pt-0 mt-0 mb-0"
                indeterminate
              ></v-progress-circular>
              Em análise por {{pagamento.username_editing}}
            </p>
            <v-btn x-small color="primary" text @click="$router.push({path: '/recebiveis/recursosdeglosa/recursosdeglosaedicao/'+pagamento.id, query:{integral:true}})" v-if="enableEditaEmTela(pagamento)" > <!--v-if="enablePagamentoIntegral(pagtoList, pagamento)"-->
              <v-icon x-small class="pr-2">fa-pencil-alt</v-icon>
              Editar recurso de Glosa 
            </v-btn> 
           
            <v-btn x-small color="primary" text @click="confirmLiberarEdicao(pagamento)"  v-if="enableLiberarEdicao(pagamento)">
              <v-icon x-small class="pr-2">fa-key</v-icon>
              Liberar edição
            </v-btn> 

            <v-btn
              x-small
              color="primary"
              text
              @click="HitoricoEventoDlg(pagamento)"
              ><v-icon x-small class="pr-2"> fa-clock</v-icon>
              Histórico de Recurso
            </v-btn>
            <v-btn
              v-if="grupoEconomico == 167 && userData.UsuarioTradimus"
              x-small
              color="primary"
              text
              @click="AbrePendenciasDlg(pagamento)"
              ><v-icon x-small class="pr-2"> fa-clock</v-icon>
              Histórico de Pendência
            </v-btn>

            <v-btn
              x-small
              color="primary"
              text
              v-if="pagamento.doc_id_frg && pagamento.etapa!='53'"
              @click="downloadDocument('frg', pagamento)"
            >
              <v-icon x-small class="pr-2">fa fa-file-excel</v-icon>
              Formularios de glosas
            </v-btn>
            <v-btn
              x-small
              color="primary"
              text
              @click="confirmToogleRecurso(pagamento, true)"
              v-if="enableAlocarRecurso(pagamento)"
              >
              <v-icon x-small class="pr-2">fa-thumbtack</v-icon>
              Alocar recurso 
            </v-btn>
            <v-btn
              x-small
              color="primary"
              text
              @click="confirmToogleRecurso(pagamento, false)"
              v-if="enableDesalocarRecurso(pagamento)"
            >
              <v-icon x-small class="pr-2">fa-thumbtack</v-icon>
              Liberar recurso
            </v-btn>
            <v-btn
              x-small
              color="primary"
              text
              @click="uploadRecurso(pagamento)"
              v-if="enableUploadRecurso(pagamento)"
            >
              <v-icon x-small class="pr-2">fa-upload</v-icon>
              Upload planilha
            </v-btn>
            <v-btn
              x-small
              color="primary"
              text
              @click="openAcompanhamentoEnvio(pagamento, 'showAnexosViewDlg')"
              v-if="enableUploadAnexos(pagamento)"
            >
              <v-icon x-small class="pr-2">fa-paperclip</v-icon>
              Upload de anexos
            </v-btn>
          <v-btn
              x-small
              color="primary"
              text
              v-if="pagamento.doc_id_reap"
              @click="downloadDocument('reap', pagamento)"
            >
              <v-icon x-small class="pr-2">fa fa-file-export</v-icon>
              Reapresentacao gerada
            </v-btn>
            <v-btn
              x-small
              color="primary"
              text
              v-if="pagamento.doc_id_xml && Number(pagamento.etapa) > 50"
              @click="downloadDocument('xml', pagamento)"
            >
              <v-icon x-small class="pr-2">fa fa-download</v-icon>
              Recurso gerado
            </v-btn>
            <v-btn
              x-small
              color="primary"
              text
              v-if="!!pagamento.doc_id_rac  && pagamento.doc_id_rac != null && pagamento.doc_id_rac != '' && pagamento.etapa!='53' && userData.UsuarioTradimus"
              @click="downloadDocument('rac', pagamento)"
            >
              <v-icon x-small class="pr-2">fa fa-download</v-icon>
              DAC acatado
            </v-btn>
            <v-btn
              x-small
              color="primary"
              text
              @click="confirmLiberarEnvio(pagamento)"
              v-if="enableLiberarEnvio(pagamento)"
            >
              <v-icon x-small class="pr-2">fa-paper-plane</v-icon>
              Liberar envio
            </v-btn>
            <v-btn
              x-small
              v-if="Number(pagamento.etapa) > 60"
              color="primary"
              text
              @click="
                $router.push({
                  path:
                    '/recebiveis/recursosdeglosa/acompanhamentodeenvio/' +
                    pagamento.id,
                })
              "
            >
              <!-- @click="openAcompanhamentoEnvio(pagamento, 'showMonitorEnvioRecursoDlg')" -->
              <v-icon x-small class="pr-2">fas fa-chalkboard-teacher</v-icon>
              Acompanhamento do envio
            </v-btn>
            <v-btn
              x-small
              v-if="
                Number(pagamento.etapa) == 98
              "
              color="primary"
              text
              @click="confirmConcluirRecurso(pagamento)"
            >
              <v-icon x-small class="pr-2">far fa-check-circle</v-icon>
              {{
                pagamento.envio_manual
                  ? "Concluir envio manual"
                  : "Concluir envio"
              }}
            </v-btn>
          </v-col>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="text-center mt-2 py-0 col-md-12">
      <v-pagination
        class="no-box-shadow"
        v-model="page"
        :length="pagination.total_pages"
        @input="getList(filterData, page)"
      ></v-pagination>
    </div>
    <MonitorEnvioRecursoDlg
      :close="
        () => {
          getList(filterData, page);
          showMonitorEnvioRecursoDlg = false;
        }
      "
      :dialog="showMonitorEnvioRecursoDlg"
      :downloadRecurso="(tipo, pagamento) => downloadDocument(tipo, pagamento)"
      :grupoEconomico="grupoEconomico"
      :info="dadosPagamento"
      :updatePage="getList"
    />
    <AnexosViewDlg
      :close="
        () => {
          getList(filterData, page);
          showAnexosViewDlg = false;
        }
      "
      :dialog="showAnexosViewDlg"
      :downloadRecurso="(tipo, pagamento) => downloadDocument(tipo, pagamento)"
      :grupoEconomico="grupoEconomico"
      :dadosPagamento="dadosPagamento"
      :updatePage="getList"
      :parametros="parametros"
    />
    <HistoricoEventoDlg
      :close="
        () => {
          getList(filterData, page);
          showHistorico = false;
        }
      "
      :dialog="showHistorico"
      :lista="historicoList"
    />
    <PendenciaDlg
      :dialog="showPendenciaDlg"
      :close="() => (showPendenciaDlg = false)"
      :grupoEconomico="grupoEconomico"
      :info="dadosPagamento"
      origem="lista"
      :pendencia="{}"
      :updatePage="() =>{}"
    />
    <InfoIntegracaoDlg
      :close="
        () => {
          showInfoIntegracao = false;
          offsetLogs = 1;
          logsPagesTotal = 0;
          offsetLotes = 1;
          lotesPagesTotal = 0;
          getLogs=[];
          getLotes=[];
        }
      "
      :dialog="showInfoIntegracao"
      :estadoList="estadoList"
      :listaLotes="loteList"
      :listaLogs="logList"
      :lotes="lotes"
      :retry="(dadosPagamento) => integrarPagamento(dadosPagamento)"
      :dadosPagamento="dadosPagamento"
      :getLogs="(pagamento, loteId, currentPage) => listarLogsIntegracao(null, pagamento, loteId, currentPage)"
      :getLotes="(pagamento, currentPage) => listarLotesIntegracao(null, pagamento, currentPage)"
      :logsPagesTotal="logsPagesTotal"
      :lotesPagesTotal="lotesPagesTotal"
    />
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
import PagamentoDataTable from "./DataTable";
import MonitorEnvioRecursoDlg from "./MonitorEnvioRecurso";
import AnexosViewDlg from "./AnexosViewDlg";
import HistoricoEventoDlg from "./HitoricoEventoDlg.vue";
import PendenciaDlg from "../recursos_de_glosa_edicao/PendenciaDlg.vue";
import InfoIntegracaoDlg from "./InfoIntegracaoDlg.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    AnexosViewDlg,
    HistoricoEventoDlg,
    InfoIntegracaoDlg,
    MonitorEnvioRecursoDlg,
    PagamentoDataTable,
    PendenciaDlg,
  },
  data() {
    return {
      estadoList: {
                "0": {descricao: 'Recurso não integrado', color: 'primary'},
                "1": {descricao: 'Em processamento', color: '#B2B842'},
                "2": {descricao: 'Em processamento', color: '#B2B842'},
                "3": {descricao: 'Integração Finalizada', color: '#32B88B'},
                "-1":{descricao: 'Finalizado com erro', color: '#D0021B'},
                "-2":{descricao: 'Integrado parcialmente com erro', color: '#FC9D0A'},
      },
      loteList: [],
      logList:[],
      logsPagesTotal: 0,
      lotesPagesTotal: 0,
      lotes:[], //[{"arquivo_id":null,"num_lote":"Selecione", "status_integracao_erp_rec":null}],
      enableFinaliza: false,
      closeOnContentClick: false,
      dadosPagamento: {},
      itemsPerPage: 5,
      page: 1,
      pageCount: 0,
      panel: null,
      parametros: {},
      positions: null,
      newPosition: null,
      grupoSelecionado: null,
      openedPanel: null,
      openInfo: false,
      headersLogin: [
        {
          text: "Prestador",
          value: "prest_nome",
          align: "left",
          sortable: false,
        },
        {
          text: "Ident. na operadora",
          value: "identificador_prestador",
          align: "left",
          sortable: false,
        },
        {
          text: "Vl.informado",
          value: "valor_informado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.liberado",
          value: "valor_liberado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.glosado",
          value: "valor_glosado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.recursado",
          value: "valor_recursado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.acatado",
          value: "valor_acatado",
          align: "right",
          sortable: false,
        },
        { text: "Ação", value: "status", align: "center", sortable: false },
      ],
      selectedLotes: [],
      selectedFilter: [],
      selectedEstadoFilter: [],
      showFilter: false,
      showMonitorEnvioRecursoDlg: false,
      showPendenciaDlg: false,
      showInfoIntegracao: false,
      status: {},
      showAnexosViewDlg: false,
      userName: null,
      //userData: null,
      valueSelect: null,
      orderBy: { sort: "data_pagamento", order: "Desc" },
      orderByList: [
        // {descricao: "Selecione", valor: null},
        {
          descricao: "Datas mais recentes",
          valor: { sort: "data_pagamento", order: "Desc" },
        },
        {
          descricao: "Datas mais antigas ",
          valor: { sort: "data_pagamento", order: "Asc" },
        },
        {
          descricao: "Maiores valores informado",
          valor: { sort: "valor_informado", order: "Desc" },
        },
        {
          descricao: "Menores valores informado",
          valor: { sort: "valor_informado", order: "Asc" },
        },
        {
          descricao: "Maiores valores liberado",
          valor: { sort: "valor_liberado", order: "Desc" },
        },
        {
          descricao: "Menores valores liberado",
          valor: { sort: "valor_liberado", order: "Asc" },
        },
        {
          descricao: "Maiores valores glosados",
          valor: { sort: "valor_glosado", order: "Desc" },
        },
        {
          descricao: "Menores valores glosados",
          valor: { sort: "valor_glosado", order: "Asc" },
        },
        {
          descricao: "Maiores valores de glosa mantida",
          valor: { sort: "valor_glosa_mantida", order: "Desc" },
        },
        {
          descricao: "Menores valores de glosa mantida",
          valor: { sort: "valor_glosa_mantida", order: "Asc" },
        },
        {
          descricao: "Maiores valores recursados",
          valor: { sort: "valor_recursado", order: "Desc" },
        },
        {
          descricao: "Menores valores recursados",
          valor: { sort: "valor_recursado", order: "Asc" },
        },
        {
          descricao: "Maiores valores de glosa acatada",
          valor: { sort: "valor_acatado", order: "Desc" },
        },
        {
          descricao: "Menores valores de glosa acatada",
          valor: { sort: "valor_acatado", order: "Asc" },
        },
      ],
      showHistorico: false,
      historicoList: null,
    };
  },
  watch: {
    list: {
      deep: true,
      handler() {
        this.panel = null;
        if(this.tipoFiltro == 'COMPETENCIA'){
          let pgto = {}
          pgto.prestador_id = this.filterData.prestador_id[0]
          pgto.operadora_ans_id = this.filterData.operadora_ans_id[0]
          pgto.data_pagamento = this.filterData.data_entre
          this.getParametrizacao(pgto)
        }
      },
    },
    filterData(val) {
      this.orderBy =
        val && val.sort
          ? this.orderByList.find(
              (el) =>
                el.valor &&
                el.valor.sort == val.sort &&
                el.valor.order == val.order
            ).valor
          : { sort: "data_pagamento", order: "Desc" };
    },
    parametros(val){
      this.parametros = val
    },
    pagination: {
      deep: true,
      handler(val) {
      this.page = val.offset
      }
    }
  },
  filters: {
    formatDateHour(date) {
      return (
        moment(date).format("L") + " às " + moment(date).format("LT") + "h"
      );
    },
  },
  mounted() {
    //this.userData = this.$store.state.userData.userData;
    this.userName = this.userData.UserName;
  },
  computed: {
    ...mapState({
      userData: (state) => state.userData.userData,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
    }),
  },
  methods: {
    ...mapActions({
      getDocumentPost: "documents/getDocumentPost",
    }),
    acaoExe(e, pagamento){
      e.stopPropagation();
        let paramModal = {
                type: "info",
                title: "",
                message: "",
                callback: null,
                btConfirm: { name: "Ok", show: true, color: "primary" },
                btCancel: { name: "Cancelar", show: false, color: "primary"},
              };
      if(pagamento.status_integracao_erp != 3){
        paramModal.title = "Pagamento Não integrado"
        paramModal.message = "Aguarde a integração do pagamento.<br>Não é possível integrar o recurso se o pagamento não foi integrado."
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        return
      }
      switch (pagamento.status_integracao_erp_rec) {
        case 0: 
          this.confirmarIntegracao(e, pagamento)
          break;
        case 1:
          paramModal.title = "Em processamento"
          paramModal.message = "Integração em processamento, aguarde o retorno do status."
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          break;
        case 3: 
        default:
          this.listarLogsIntegracao(e, pagamento, null, 1)
          break;
      }
    },
    confirmarIntegracao(e, pagamento) {
      e.stopPropagation();
      let paramModal = {
          type: "info",
          title: "Confirma integração do recurso de glosa?",
          message: "Confirme a integração do recurso de glosa selecionado.",
          callback: () => {
            this.integrarPagamento(pagamento);
          },
          btConfirm: { name: "Confirmar", show: true, color: "primary" },
          btCancel: { name: "Cancelar", show: true, color: "primary"},
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    integrarPagamento(pagamento) {
      let grupo_economico = this.$store.state.permissions.grupoEconomico;
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "concluirintegracaorec",
            Payload: { grupo_economico, pagamento_id: pagamento.id, prestador_id: pagamento.prestador_id },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            pagamento.status_integracao_erp_rec = 1;
          },
          btConfirm: { name: "OK", show: true, color: "primary" },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
    listarLotesIntegracao(e, pagamento, currentPage) {
      if (e !== null) e.stopPropagation();
      this.dadosPagamento = pagamento;
      this.offsetLotes = currentPage;
      let grupo_economico = this.$store.state.permissions.grupoEconomico;
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "getlotesrecursoitg",
            Payload: { grupo_economico, pagamento_id: pagamento.id, offset: this.offsetLotes, limit: 10 },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        this.lotesPagesTotal = response.total_pages;
        this.lotes = response.Lotes; 
        this.lotes.unshift({arquivo_id: null, num_lote: "Selecione", status_integracao_erp_rec: null})
        this.loteList = response.dados;
        this.showInfoIntegracao = true;
        this.$nextTick();
      });
    },
    listarLogsIntegracao(e, pagamento, lote_id = '', currentPage) {
      if (e !== null) e.stopPropagation();
      this.dadosPagamento = pagamento;
      this.loteId = lote_id; //manter para caso de desistência de apenas nivel pagto e voltar por lote....
      this.offsetLogs = currentPage;
      let grupo_economico = this.$store.state.permissions.grupoEconomico;
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "getlogintegracaorec",
            Payload: { grupo_economico, lote_id, pagamento_id: pagamento.id, offset: this.offsetLogs, limit: 10 },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        this.logsPagesTotal = response.total_pages;
        this.logList = response.dados;
        this.showInfoIntegracao = true;
        this.$nextTick();
      });
    },
    downloadFile(acao, filterData, doCallBack) {
      this.$store.commit("showLoader", { circle: true }, {root: true});
      let Payload = { ...filterData };
      this.$store.dispatch(
        "documents/getDocumentPost",
        {
          Payload,
          acao,
          callback: doCallBack
            ? () =>
                setTimeout(() => {
                  this.getList(this.filterData, this.pagination.offset);
                }, 500)
            : null,
        },
        { root: true }
      );
    },
    openAcompanhamentoEnvio(pagamento, modal) {
      this.dadosPagamento = pagamento;
      this[modal] = true;
    },
    openPanel(ind, pagamento) {
      if (this.panel != ind) {
        this.getParametrizacao(pagamento);
        this.getPagamentos(pagamento.id);
      }
    },
    confirmLiberarEnvio(pagamento) {
      this.dadosPagamento = pagamento;
      let paramModal = {
        type: "info",
        title: "Liberar o envio do recurso de glosa",
        message: `Deseja liberar o envio do recurso de glosa?`,
        callback: () => this.liberarEnvio(pagamento),
        btConfirm: { name: "Liberar envio", show: true, color: "primary" },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    liberarEnvio(pagamento) {
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "liberarenviorecursoglosa",
            payload: {
              grupo_economico: this.grupoEconomico,
              pagamento_id: pagamento.id,
            },
          },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          pagamento.etapa = 70;
        });
    },
    confirmConcluirRecurso(pagamento) {
      this.dadosPagamento = pagamento;
      let paramModal = {
        type: "info",
        title: "Concluir o recurso de glosa",
        message: (pagamento.protocolos_informados && pagamento.envio_manual) || !pagamento.envio_manual
          ? `Deseja concluir o recurso de glosa?`
          : `Existem lotes sem protocolo ou data de envio. Deseja concluir, mesmo assim, o recurso de glosa?`,
        callback: () => this.concluirRecurso(pagamento),
        btConfirm: { name: "Concluir", show: true, color: "error" },
        btExtra: (pagamento.protocolos_informados && pagamento.envio_manual) || !pagamento.envio_manual
          ? null
          : {
              name: "Inserir protocolos",
              show: true,
              callback: () => this.$router.push({ path: '/recebiveis/recursosdeglosa/acompanhamentodeenvio/' + pagamento.id,
                })
            },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    concluirRecurso(pagamento) {
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "concluirrecursoglosa",
            payload: {
              grupo_economico: this.grupoEconomico,
              pagamento_id: pagamento.id,
            },
          },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          this.getList(this.filterData, this.page);
        });
    },
    confirmToogleRecurso(pagamento, isAlocar) {
      this.dadosPagamento = pagamento;
      let btConfirma = isAlocar ? "Alocar recurso" : "Desalocar recurso";
      let paramModal = {
        type: "info",
        title: isAlocar
          ? "Alocar o recurso de glosa"
          : "Desalocar o recurso de glosa",
        message: isAlocar
          ? `Ao alocar a análise do recurso para o seu usuário, apenas você poderá fazer o upload da planilha preenchida. <br>Deseja realmente alocar o recurso?`
          : `Ao desalocar a análise do recurso, você não poderá mais fazer o upload da planilha de recurso. <br> Deseja desalocar o recurso?`,
        callback: () => this.toggleRecurso(pagamento, isAlocar),
        btConfirm: { name: btConfirma, show: true, color: "primary" },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    confirmLiberarEdicao(pagamento) {
      //, parcial
      let paramModal = {
        type: "info",
        title: "Desalocar o recurso de glosa",
        message: `Ao desalocar a análise do recurso, qualquer usuário poderá alocar este recurso e fazer o upload da planilha de recurso. <br> Deseja desalocar o recurso?`,
        callback: () => this.toggleRecurso(pagamento, false),
        btConfirm: { name: "Desalocar recurso", show: true, color: "primary" },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    enableAlocarRecurso(pagamento){
      let etapasPermitidas = ['40', '50', '56', '60', '80', '90']
      let exibe = etapasPermitidas.includes(pagamento.etapa) && 
                  (this.parametros && this.parametros.RG_ALOCA_RECURSO) &&
                  (pagamento.username_editing == null || pagamento.username_editing == "");
      return exibe;
    },
    enableDesalocarRecurso(pagamento){
      let etapasPermitidas = ['50', '56', '60', '70', '80', '90']
      let exibe = etapasPermitidas.includes(pagamento.etapa) && 
                  (this.parametros && this.parametros.RG_ALOCA_RECURSO) &&
                  pagamento.username_editing &&
                  pagamento.username_editing == this.userName;
      return exibe;
    },
    enableLiberarEdicao(pagamento) {
      let podeLiberarEdicao =
        this.userData &&
        // this.pagtoList.length !=
        //  this.pagtoList.filter((el) => el.is_edited).length && 
          (this.userData.Permissao.recebiveis &&
        (this.userData.Permissao.recebiveis.includes("gestor") ||
          this.userData.Permissao.recebiveis.includes("coordenador"))) &&
        pagamento.is_editing &&
        pagamento.username_editing &&
        pagamento.username_editing != this.userName &&
        //(Number(pagamento.etapa) == 50 &&
        this.parametros.RG_ALOCA_RECURSO;
      return podeLiberarEdicao;
    },
    enableLiberarEnvio(pagamento) {
      let etapasPermitidas = ["56"]
      let exibe =
        etapasPermitidas.includes(pagamento.etapa) //&&
        //this.parametros &&
        //this.parametros.RG_LIBERA_ENVIO 
        // && (pagamento.valor_glosado).toFixed(2) -
        //   (pagamento.valor_acatado + pagamento.valor_recursado).toFixed(2) ==
        //   0;
      return exibe;
    },
    enableEditaEmTela(pagamento) {
      let etapasPermitidas = ["50", "56", "60", "80", "90"]
      if(!this.parametros.RG_ALOCA_RECURSO){
          etapasPermitidas.push("40");
      }
      let exibe = etapasPermitidas.includes(pagamento.etapa) && 
                (pagamento.username_editing == this.userName || (this.parametros && !this.parametros.RG_ALOCA_RECURSO));
      return exibe;
    },
    enableUploadRecurso(pagamento){
      let etapasPermitidas = ["50", "56", "60", "80", "90"]
      // if(this.parametros && (!this.parametros.RG_LIBERA_ENVIO || !this.parametros.RG_ALOCA_RECURSO)){
      //     etapasPermitidas.push("70")
      // }
      let exibe = this.parametros 
                && (!this.parametros.RG_BLOQUEIA_UPLOAD_FRG || (this.parametros.RG_BLOQUEIA_UPLOAD_FRG && (this.parametros.RG_BLOQUEIA_UPLOAD_FRG == false || this.parametros.RG_BLOQUEIA_UPLOAD_FRG.toString().toLowerCase() == 'false') ))
                && etapasPermitidas.includes(pagamento.etapa) && 
                (pagamento.username_editing == this.userName || !this.parametros.RG_ALOCA_RECURSO);
      return exibe;
    },
    enableUploadAnexos(pagamento) {
      let etapasPermitidas = ["50","56","80"]
      let exibe =
        etapasPermitidas.includes(pagamento.etapa) &&
        this.parametros &&
        this.parametros.RG_ENVIO_ANEXO

      return exibe;
    },
    toggleRecurso(pagamento, isAlocar) {
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: isAlocar ? "alocarecurso" : "desalocarecurso",
            payload: {
              grupo_economico: this.grupoEconomico,
              pagamento_id: pagamento.id,
            },
          },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }

          if (response.etapa != 0) pagamento.etapa = response.etapa.toString();

          let paramModal = {
            type: "success",
            title: response.tituloBox,
            message: response.mensagem,
            //callback: () => this.getList(this.filterData, this.page),
            btConfirm: { name: "OK", show: true, color: "primary" },
          };
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        });

      isAlocar
        ? ((pagamento.username_editing = this.userName),
          (pagamento.is_editing = true))
        : ((pagamento.etapa = "40"),
          (pagamento.username_editing = ""),
          (pagamento.is_editing = false));

      isAlocar = !!isAlocar;
      this.confirmToogleRecurso(pagamento, isAlocar);
    },
    AbrePendenciasDlg(pagamento){
      this.dadosPagamento = pagamento;
      this.showPendenciaDlg = true;

    },
    HitoricoEventoDlg(pagamento) {
      let payload = { grupo_economico: this.grupoEconomico, id: pagamento.id };
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "gethistoricopagamentospublicados",
            Payload: payload,
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        this.historicoList = response.dados;
        this.showHistorico = true;
      });
    },
    downloadDocument(tipo, pagamento) {
      let acao = "downloadrecursoglosa";
      let Payload = {
        doc_id: pagamento["doc_id_" + tipo],
        pagamento_id: pagamento.id,
        grupo_economico: this.grupoEconomico,
        tipo,
      };
      this.getDocumentPost({
        Payload,
        acao,
        callback: setTimeout(() => {
          this.getList(this.filterData, this.page);
        }, 5000),
      });
    },
    getColorByDate(date_prazo) {
      let cor = "";
      let prazo = moment(date_prazo);
      let diasRestantes = prazo.diff(moment(), "days");
      let estado =
        diasRestantes < 0
          ? "acima_do_prazo"
          : diasRestantes < 6 && diasRestantes > -1
          ? "prazo_critico"
          : "";
      switch (estado) {
        case "acima_do_prazo":
          cor = "acima-do-prazo";
          break;
        case "prazo_critico":
          cor = "prazo-critico";
          break;
      }
      return cor;
    },
    getStatusData(id, param) {
      let status = this.statusList.find((el) => el.id == id);
      return status ? status[param] : "";
    },
    getPrazoEmDias(date_prazo) {
      let prazo = moment(date_prazo);
      let diasRestantes = prazo.diff(moment(), "days");
      let mensagem =
        diasRestantes < 0
          ? `Vencido a ${diasRestantes * -1} dias`
          : `Prazo final em ${diasRestantes} dias`;
      return mensagem;
    },
    getHeadersLogin(etapa) {
      let newHeaders = [...this.headersLogin];
      if (etapa == 99) {
        newHeaders.pop();
      }
      return newHeaders;
    },
    modalVideo(){
      let paramModal = {
          codigo: "754810435",
          title: "Como corrigir o erro no formulário do recurso de glosa",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },
    getParametrizacao(pagamento) {
      let { prestador_id, operadora_ans_id } = pagamento
      let opts = {
        query: [
          {
            Modulo: "Portal",
            Acao: "getparametrizacoes",
            Payload: {
              grupo_economico: this.grupoEconomico,
              prestador_id,
              operadora_ans_id,
            },
          },
        ],
        noLoader: true,
      };
      this.$store
        .dispatch("request/doRequest", opts)
        .then((resp) => {
          this.parametros = resp.parametros
          if(this.tipoFiltro == 'COMPETENCIA'){
            let pagtosInaptos = this.list.filter((el) => el.etapa < 75 && el.valor_glosado > 0)
            this.enableFinaliza = pagtosInaptos== 0 && this.parametros && this.parametros.RG_FINALIZA_ENVIO && this.parametros.RG_TipoLibera? (this.parametros.RG_FINALIZA_ENVIO && this.parametros.RG_TipoLibera == 'COMP') : false;
          }
          else 
            this.enableFinaliza = false
        
        });
    },
    enablePagamentoIntegral(pagamentos, pagamento) {
      let etapasPermitidas = ["50", "53", "56", "60", "75", "80", "90"]
      if(!this.parametros.RG_ALOCA_RECURSO){
          etapasPermitidas.push("40");
      }
      if (
        !etapasPermitidas.includes(pagamento.etapa) ||
        //O pagamento pode ser editado e reeditado até o início do envio.
        //A glosa regular, a reapresentação e a glosa mantida são editadas em tempos diferentes.
        //O controle da edição se dará no nível de guias e itens
        //pagamento.is_edited ||
        //pagamentos.length == pagamentos.filter((el) => el.is_edited).length ||
        !this.parametros.RG_EDITA_EM_TELA
      ) {
        return false;
      }
      let habilitarPagamentoIntegral = this.parametros.RG_EDITA_EM_TELA && (
        !pagamento.is_editing ||
        (pagamento.is_editing && this.parametros.RG_ALOCA_RECURSO && 
        pagamento.username_editing == this.userName) ||
          !this.parametros.RG_ALOCA_RECURSO
        );
        
      return habilitarPagamentoIntegral;
    },

    showSelectedFilter(filter) {
      this.showFilter = true;
      this.selectedEstadoFilter = filter;
      this.openInfo = false;
    },
  },
  props: {
    anexarEmMassa: Function,
    tipoFiltro: String,
    list: Array,
    openModal: Function,
    pagination: Object,
    pagtoList: Array,
    filterData: Object,
    getList: Function,
    getPagamentos: Function,
    historico: Object,
    statusList: Array,
    uploadRecurso: Function,
    totais: Object,
  },
};
</script>

<style lang="scss">
.no-box-shadow,
.no-box-shadow * {
  box-shadow: 0 0 0 0 !important;
}
button.v-expansion-panel-header {
  background-color: #eff3f8;
  border-radius: 2px;
  padding: 0;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel::after {
  display: none;
}
.v-expansion-panel-content {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -24px;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff;
}
.text-list {
  font-size: 13px;
}
.text-list.space {
  margin-right: 3px;
}
.text-list.pres {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.check-header-rec {
  position: absolute;
  margin-top: 20px;
  margin-left: 3px;
}
.check-header-rec2 {
  position: absolute;
  margin-top: 9px;
  margin-left: -4px;
}
.check-content {
  position: absolute;
  margin-top: -16px;
}
.check-border {
  border: none;
}
.porcentagem {
  border-radius: 8px;
  padding: 0 0 0 0;
  text-align: center;
  width: 100%;
  border: 1.5px solid #9e9e9e;
  font-size: 12px;
  color: #9e9e9e;
}
.v-expansion-panel-header .row {
  align-items: center;
}
.v-chip {
  border-bottom-style: solid;
  left: 0.8rem;
}
.v-chip:nth-child(3) {
  margin-left: 0.3rem;
}
.v-chip:last-child {
  margin-left: 0.3rem;
}
#check-color {
  .v-icon.v-icon {
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 24px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #118aca;
  }
}
.acima-do-prazo {
  color: #d0021b !important;
  font-weight: bold;
}
.prazo-critico {
  color: #fc9e0d !important;
  font-weight: bold;
}
</style>
